function flickitySliders() {
	document.addEventListener("DOMContentLoaded", function(event) { 
		const flickitySliders = document.querySelectorAll('[data-flickity-slider]');
	
	flickitySliders.forEach(slider => {
			const flkty = new Flickity(slider, {
				//options
				cellAlign: 'left',
				contain: true,
				pageDots: false,
				wrapAround: true
			});
		});
	});
}
// Using typed.js instead
function changeHeroWords(){
		// Grab both mobile and DT last word of headline
		const changingWords = document.querySelectorAll('[data-changing-word]');
		
		if (changingWords.length === 0) return;

		const firstWord = changingWords[0].innerText;
		const wordList = document.querySelector('[data-word-list]').innerText;

		if (!wordList) return;
	
		//Trim a split string to avoid spacing issues
		let wordListArr = wordList.trim().split(',');
		for (let i = 0; i < wordListArr.length; i++){
			wordListArr[i] = wordListArr[i].trim();
		}
		//Add current word to end of arr for future ticking
		if(firstWord && wordListArr)
			wordListArr.push(firstWord)
	
		//Function to change word in title
		function changeWord(arr){
			if(!wordListArr) return;
	
		// Variable to keep track of current word on title
		let nextWord = wordListArr[0];
	
			setInterval(() => {
				changingWords.forEach((el) => {
					el.innerText = nextWord;
					
					// Toggle the animate class on/off to trigger the animation
					el.classList.toggle('animate');
					setTimeout(() => el.classList.toggle('animate'), 100)
				});
	
				//Iterate next word
				if(arr.indexOf(nextWord) < arr.length - 1)
					nextWord = arr[arr.indexOf(nextWord) + 1];
				else
					nextWord = arr[0];
			
			}, 3000)
		}
	
		//Init function
		if (wordListArr)
			changeWord(wordListArr);	
}

(function init() {
	flickitySliders();
})();
